module.exports = __webpack_public_path__ + "a1ca5027b75edfba058501ea6e807fde.png";